import styled from 'styled-components';

export const MarkerComponent = styled.div`
  cursor: pointer;
  zindex: 10;
  user-select: none;
`;

export const CustomPin = styled.img`
  cursor: pointer;
  zindex: 10;
  user-select: none;
  width: 42px;
  height: 42px;
  object-fit: contain;
  transform: translate(-50%, -100%);
`;

export default MarkerComponent;
